import {
  AutomationTaskInput,
  RequirementConditionType
} from 'generated-graphql/types';

const isRequirementConditionsEqual = (
  task: AutomationTaskInput,
  nextTask: AutomationTaskInput
) => {
  const isRequirementConditionsEqual = task.requirementConditions.every(
    (condition, index) => {
      const nextCondition = nextTask.requirementConditions[index];

      if (
        condition.type === RequirementConditionType.CandidateStatusCondition &&
        nextCondition.type ===
          RequirementConditionType.AnyCandidateStatusCondition
      ) {
        return true;
      }

      return (
        // Using loose equality to compare the values because the values can be null or undefined
        condition.type == nextCondition.type &&
        condition.operator == nextCondition.operator &&
        condition.scoreScaled == nextCondition.scoreScaled &&
        condition.candidateStatus == nextCondition.candidateStatus &&
        condition.conversationStatus == nextCondition.conversationStatus
      );
    }
  );

  return isRequirementConditionsEqual;
};

export const findDuplicatedAutomationTasks = (
  automationTasks: AutomationTaskInput[]
) => {
  const duplicates: AutomationTaskInput[] = [];

  automationTasks.forEach((task, index) => {
    const isDuplicate = automationTasks.some((nextTask, i) => {
      if (index !== i) {
        const isRequirementConditionsEqualValue = isRequirementConditionsEqual(
          task,
          nextTask
        );

        const isActionEqual = nextTask.action.type === task.action.type;
        return isRequirementConditionsEqualValue && isActionEqual;
      }
      return false;
    });

    if (isDuplicate) {
      duplicates.push(task);
    }
  });

  return duplicates;
};
